import React from 'react';
import { bool } from 'prop-types';
import { Card, Link, Typography } from '@one-thd/sui-atomic-components';
import { Orders } from '@one-thd/sui-icons';
import { RecentPurchasesTableHeader, RecentPurchasesCardHeader } from '../subcomponents/cardHeader/RecentPurchasesHeader';
import { purchaseHistoryURL } from '../../../constants';

function RecentPurchasesFallbackTable({ isError, noData }) {
  let headerMessage;
  let subheaderMessage;
  let testIdType;

  if (isError) {
    testIdType = 'error';
    headerMessage = (
      <Typography>Hmm, we couldn&apos;t load your orders</Typography>
    );
    subheaderMessage = (
      <Typography>Try refreshing the page or check back later.</Typography>
    );
  } else if (noData) {
    testIdType = 'fallback';
    headerMessage = <Typography>No Recent Orders</Typography>;
    subheaderMessage = (
      <Typography>You haven&apos;t placed any orders recently</Typography>
    );
  }

  return (
    <Card data-testid={`recentOrders-card-b2b-${testIdType}-table`} className="sui-h-full sui-w-full" data-component="RecentPurchasesFallbackTable">
      <RecentPurchasesTableHeader />
      <div
        data-testid={`recentOrders-content-b2b-${testIdType}-table`}
        className="sui-flex sui-items-center sui-h-96 sui-w-full sui-flex-col sui-justify-center"
        data-type="container"
      >
        <Orders size="large" />
        <span className="sui-mt-8 sui-mb-4">{headerMessage}</span>
        <span className="sui-mb-8">{subheaderMessage}</span>
        <Link href={purchaseHistoryURL}>View All Orders</Link>
      </div>
    </Card>
  );
}

function RecentPurchasesFallbackCard({ isError, noData }) {
  let headerMessage;
  let subheaderMessage;
  let testIdType;

  if (isError) {
    testIdType = 'error';
    headerMessage = (
      <Typography>Hmm, we couldn&apos;t load your orders</Typography>
    );
    subheaderMessage = (
      <Typography>Try refreshing the page or check back later.</Typography>
    );
  } else if (noData) {
    testIdType = 'fallback';
    headerMessage = <Typography>No Recent Orders</Typography>;
    subheaderMessage = (
      <Typography>You haven&apos;t placed any orders recently</Typography>
    );
  }

  return (
    <Card data-testid={`recentOrders-card-b2b-${testIdType}-carousel`} className="sui-h-full sui-w-full" data-component="RecentPurchasesFallbackCard">
      <RecentPurchasesCardHeader />
      <div
        data-testid={`recentOrders-content-b2b-${testIdType}-carousel`}
        className="sui-flex sui-items-center sui-h-96 sui-w-full sui-flex-col sui-justify-center"
        data-type="container"
      >
        <Orders size="large" />
        <span className="sui-mt-8 sui-mb-4">{headerMessage}</span>
        <span className="sui-mb-8">{subheaderMessage}</span>
        <Link href={purchaseHistoryURL}>View All Orders</Link>
      </div>
    </Card>
  );
}

RecentPurchasesFallbackTable.propTypes = {
  isError: bool,
  noData: bool,
};

RecentPurchasesFallbackTable.defaultProps = {
  isError: false,
  noData: false,
};

RecentPurchasesFallbackCard.propTypes = {
  isError: bool,
  noData: bool,
};

RecentPurchasesFallbackCard.defaultProps = {
  isError: false,
  noData: false,
};

export { RecentPurchasesFallbackTable, RecentPurchasesFallbackCard };
